import React, { useEffect, useState } from "react"
import axios from '../../../../axios-instance';
import { getCustomURLs } from "../../../../helpers/getCustomURLs";
import { getHeaders } from "../../../../helpers/getHeaders";
import ls from 'localstorage-slim';
import { paymentProvidersOptions } from "../../../SeasonPass/constants";
import styles from './PaymentMethodsPage.module.sass';
import CheckBox from "../../../../components/UI/Checkbox/CheckBox";
import { toast } from "react-toastify";

export const PaymentMethodsPage = () => {
    const [state, setStateInternal] = useState({
        paymentMethods: [],
    });
    const setState = (changes) => setStateInternal(v => { return { ...v, ...changes } });

    useEffect(() => {
        (async () => {
            const { data } = await axios.get(`${getCustomURLs().API_URL}/PaymentMethod`, {
                headers: getHeaders(ls.get('user').token),
            });

            setState({ paymentMethods: data });
        })();
    }, []);

    const changeMethodDefault = (v, id) => {
        const method = state.paymentMethods.find(m => m.id === id);

        if (method) {
            method.isPromoterDefault = !method.isPromoterDefault;
            setState({ paymentMethods: state.paymentMethods.map(m => m) });
        }
    }

    const changeMethodName = (v, id) => {
        const method = state.paymentMethods.find(m => m.id === id);

        if (method) {
            method.paymentMethodName = v;
            setState({ paymentMethods: state.paymentMethods.map(m => m) });
        }
    }

    const savePaymentMethods = async () => {
        try {
            const { data } = await axios.put(`${getCustomURLs().API_URL}/PaymentMethod`,
                state.paymentMethods,
                {
                    headers: getHeaders(ls.get('user').token),
                });

            toast.success('Saved');
        } catch (error) {
            toast.success('Failed');
        }
    }

    return <div>

        <section className={styles['payment-method-list']}>
            {state.paymentMethods.map(m => <div className={styles['payment-method-item']}>

                <span>Payment provider: {paymentProvidersOptions.find(i => i.id === m.provider).label}</span>

                <div>
                    <label>Name: </label>
                    <input type="text"
                        onChange={e => changeMethodName(e.target.value, m.id)}
                        placeholder="Name"
                        value={m.paymentMethodName} />
                </div>

                <div>
                    <CheckBox
                        name="change-default"
                        id={`change-default_${m.id}`}
                        checked={m.isPromoterDefault}
                        onChange={v => changeMethodDefault(v.target.checked, m.id)}>
                        Used as default
                    </CheckBox>


                </div>
            </div>)}
        </section>


        <div className={styles['footer']}>

            <button className="btn-primary-new admin"
                onClick={savePaymentMethods}>
                Save
            </button>

        </div>

    </div>
}